import React from 'react';
import { Alert, Checkbox, FormControlLabel, Typography } from '@mui/material';

export default function DemoScheduleExceptionPanel({
  reason,
  allowOverride,
  onAllowOverrideChange,
  disabled = false,
}) {
  if (!reason) return null;

  return (
    <Alert severity="warning" sx={{ mt: 1.5 }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        Schedule exception required
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {reason}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!allowOverride}
            disabled={disabled}
            onChange={(e) => onAllowOverrideChange(e.target.checked)}
          />
        }
        label="Schedule anyway — I confirm this exception"
      />
    </Alert>
  );
}
